/* Same-origin, same-session opaque draft handles. Artwork/configuration stay in the
 * existing server draft; only credentials and pre-upload selections live here. */
(()=>{'use strict';const prefix='yi2c-express-draft-v1:',ttl=60*60*1000;
const valid=token=>/^[0-9a-f]{64}$/.test(token||'');
window.YI2CExpressDraft={
 create(){const bytes=crypto.getRandomValues(new Uint8Array(32));return [...bytes].map(b=>b.toString(16).padStart(2,'0')).join('')},
 read(token){if(!valid(token))return null;try{const value=JSON.parse(sessionStorage.getItem(prefix+token)||'null');if(!value||value.expiresAt<=Date.now()){sessionStorage.removeItem(prefix+token);return null}return value}catch{return null}},
 write(token,value){if(!valid(token))throw new Error('INVALID_DRAFT');sessionStorage.setItem(prefix+token,JSON.stringify({...value,expiresAt:Date.now()+ttl}));return token},
 remove(token){if(valid(token))sessionStorage.removeItem(prefix+token)},valid
};})();
